<pw-view-title *ngIf="(pos$ | async) as pos">
  Dokumente {{pos.NAME}}
</pw-view-title>

<mat-form-field>
  <mat-select #groupInput [formControl]="groupSelectControl">
    <mat-option>Keine Gruppierung</mat-option>
    <mat-option [value]="'DOKUMENTART'">Dokumentart</mat-option>
    <mat-option [value]="'DOKUMENTFORM'">Dokumentform</mat-option>
    <mat-option [value]="'ERSTELLERNAME'">Ersteller</mat-option>
  </mat-select>
</mat-form-field>

<mat-nav-list *ngIf="documents$ | async as groupedDocuments">
  <ng-container *ngFor="let key of groupedDocuments.keys()">
    <div mat-subheader>{{key}}</div>
    <mat-list-item *ngFor="let doc of groupedDocuments.get(key)">
      <img matListItemIcon src="{{doc.ICON_URL}}">
      <span matListItemLine>{{doc.NAME}}</span>
      <span class="info">
        <span class="version">{{doc.VERSIONNR}}</span>
        <span class="kind">{{doc.DOKUMENTART}}</span>
        <span class="form">{{doc.DOKUMENTFORM}}</span>
      </span>

      <button mat-button (click)="downloadDocument(doc)">
        <mat-icon>file_download</mat-icon>
      </button>
    </mat-list-item>
    <mat-divider></mat-divider>
  </ng-container>
</mat-nav-list>

<button mat-mini-fab style="position: fixed; bottom: 20px; right: 20px" (click)="uploadDocument()">
  <mat-icon>file_upload</mat-icon>
</button>

